import React from "react";
import AsttCard from "../ASTT Card/asttCard";
import UserDetails from "../UserDetails/UserDetails";
import classes from "./userTable.module.css";
import Grid from "@mui/material/Grid";
import { styled } from "@mui/material/styles";
import Paper from "@mui/material/Paper";
import AsttButton from "../AsttButton/AsttButton";
import moment from "moment";

const UserTable = (props) => {
  console.log(props);

  const Item = styled(Paper)(({ theme }) => ({
    textAlign: "center",
    boxShadow: "none",
  }));

  const viewDetailsHandler = () => {
    const path = `/trainee-details/${props.userDetails.oracleId}/${props.userDetails.firstName}/${props.userDetails.lastName}`;
    window.open(
      `/trainee-details/${props.userDetails.oracleId}/${props.userDetails.firstName}/${props.userDetails.lastName}`,
      "_blank",
    );
  };
  return (
    <div>
      <AsttCard key={props.userDetails.oracleId}>
        <Grid container spacing={2}>
          <Grid item xs={8}>
            <UserDetails data={props.userDetails} />
          </Grid>
          <Grid item xs={4}>
            <Item className={classes.widthbutton}>
              <AsttButton onClick={viewDetailsHandler}>View Details</AsttButton>
            </Item>
            <p className={classes.lastUpdate}>
              (last Update :{" "}
              {moment(props.userDetails.lastUpdate).format("YYYY-MM-DD")})
            </p>
          </Grid>
        </Grid>
      </AsttCard>
    </div>
  );
};
export default UserTable;
